import { Component } from '@angular/core';

@Component({
  selector: 'app-management',
  imports: [],
  templateUrl: './management.html',
  styleUrl: './management.scss'
})
export class Management {

}
